export const ORDER_DOCUMENTS_TABLE_COLUMNS = [
    {name: "File", mnemonic: "name", ui_class: "str", content_align: "left"},
    {name: "Size", mnemonic: "file_size", ui_class: "str", shrink: true},
    {name: "Date", mnemonic: "updated_at", ui_class: "datetime", shrink: true},
    {name: "Actions", mnemonic: "uuid", ui_class: "str", header_align: "right", content_align: "right", shrink: true},
];
